<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn fab  dark large color="brown darken-4" fixed right bottom><v-icon>add</v-icon></v-btn>
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>ADD CAMPUS</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
                
                Firstly you must add a campus in order to link a 
                movie to a campus
                
             </v-card-text>
             <v-card-text>
                 <v-form class="px-3" ref="form"> 
                     <v-text-field label="Name" v-model="name" @keypress="isName" :rules="nameRules" prepend-icon="folder"></v-text-field>
                     <v-icon>file_upload</v-icon> <span class="flex"><b>   Select Image File  </b> <input type="file" class="file"/></span>
                     <br/><span v-if="fileerror" class="red--text">You must select a file</span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled">Add Campus</v-btn>
             </v-card-actions>
         </v-card>

        </v-dialog>
         <v-snackbar v-model="show" color="success">{{message}}</v-snackbar>
   
   </span>
</template>

<script>
import {addModuleWithAttachment} from '@/model';
import moment from 'moment';

export default {
    name: 'AddCampus',
    data() {
        return {
            isDisabled:false,
            name:'',
            fileerror:false,
            show:false,
            message:'',
           nameRules:[
               v => v.length >=3  || "Minimum length is 3 characters",
               v => v.length <=10  || "Maximum length is 10 characters",
               
           ]

        };
    },
    methods: {
        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) && charcode !== 46 && charcode !== 32){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        add() {
            let self=this;
            if(this.$refs.form.validate()){
            let datenow = moment().format('DD/MM/YYYY');
            let input = document.querySelector('.file');
            
            let file = input.files[0];
            console.log(input.files);
            if(file){
                this.fileerror = false;
                
            }else{
                console.log("Choi")
                this.fileerror = true
                return;
            }
            let useradd = this.$store.getters.getStaff.name;
            console.log(file.type);
            console.log(useradd); 
            let newitem = {name:this.name.toLowerCase(),movies:[],file:file.type,dateadded:datenow,useradd:useradd};
            self.isDisabled = true;
            
              addModuleWithAttachment('campus','campuses',this.name.toLowerCase(),newitem,file,function(response){
                  if(response){
                      console.log("This is response: ",response);
                     self.message = "It has been succesfully added to your campuses";
                     self.show=true;
                     // alert('It has been succesfully added to your campuses');
                      self.$store.dispatch('updateCampus',true);
                      self.isDisabled = false;
                  }else{
                      console.log(null);
                      self.isDisabled = false;
                  }

               })
            }
        }
    }
};
</script>

<style scoped>
</style>